<template>
  <app-view-default-template class="app-view-default-template-copyrights">
    <div>
      <app-content-title label="Copyright and trademarks"></app-content-title>
    </div>

    <p>
      All content is developed and/or gathered by Loyal Solutions and/or subsidiaries, for the purpose of developing
      and running this homepage. All elements are the property of Loyal Solutions A/S. Content, text, pictures etc.
      may not be quoted or reproduced in any manner without the prior written consent from Loyal Solutions A/S.
      Please note that reg. trademarks are used on the website including, but not limited to Loyal Solutions,
      LoyalTfacts&reg;, Loyalty Holdings A/S. <br><br>

      <strong>
        <span class="text-center">By viewing this homepage, you accept all terms and conditions applicable.</span>
      </strong>
    </p>
  </app-view-default-template>
</template>

<script>
  import AppViewDefaultTemplate from '@/components/layout/templates/view/AppViewTemplateDefault';
  import AppContentTitle from '@/components/ui/titles/AppContentTitle';

  export default {
      name: 'Copyrights',

      components: {
        AppViewDefaultTemplate, AppContentTitle,
      },
  }
</script>

<style lang="scss">
  .app-view-default-template-copyrights {
    background-color: white;
    min-height: calc(100vh - 100px);
  }
</style>
